module.exports = __webpack_public_path__ + "static/island-cdfd3329b9e67fa094d6efd3d238a919.jpg";